import React from 'react';
import { observer } from 'mobx-react';

import { Field } from 'libs/forms/views/field';
import { Validation as ValidationComponent } from 'libs/forms/views/validation';
import { InputWrapper } from 'libs/forms/styles';
import { DecimalFieldStore } from 'libs/forms/fieldStores';
import { NumberInput, NumberInputField } from '@chakra-ui/react';
import i18next from 'i18next';
import { reaction, comparer } from 'mobx';

@observer
export class DecimalField extends Field {
  static defaultStore = DecimalFieldStore;

  focusAfterDelete = () => {
    const { fieldStore } = this.props;
    if (fieldStore.ref) fieldStore.ref.focus();
    fieldStore.SetFocus(true);
  };

  componentDidMount() {
    this.disposer = reaction(
      () => ({
        value: this.props.fieldStore.value,
        fieldStore: this.props.fieldStore,
      }),
      ({ fieldStore }) => {
        fieldStore.valFromStore();
      },
      { fireImmediately: true, equals: comparer.shallow },
    );
  }

  componentWillUnmount() {
    this.disposer();
  }

  onFocus = e => {
    this.props.fieldStore.valFromStore();
    e.target.selectionStart = this.cursor;
  };

  onBlur = () => {
    this.props.fieldStore.updateValue(this.props.fieldStore.inputVal);
  };

  render() {
    const { fieldStore, editComponent, noValidation, responsive } = this.props;
    const Tag = editComponent || InputWrapper;
    const value = fieldStore.inputVal;

    return (
      <Tag focussed={fieldStore.isFocussed} responsive={responsive}>
        <NumberInput
          ref={ref => {
            fieldStore.SetRef(ref);
          }}
          inputMode='decimal'
          precision={2}
          autoFocus={fieldStore.autoFocus}
          id={this.inputId}
          className='inputNoBorder'
          value={value}
          placeholder={
            fieldStore.conf.placeholder &&
            i18next.t(fieldStore.conf.placeholder)
          }
          onChange={fieldStore.updateInputVal}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          posting={
            fieldStore.formStore.posting
              ? fieldStore.formStore.posting.toString()
              : undefined
          }
          autoComplete='off'
        >
          <NumberInputField
            h='auto'
            px='0'
            borderRadius='0'
            borderWidth='0'
            _focus={{ boxShadow: 'none', borderColor: '#fff' }}
          />
          {!noValidation && !fieldStore.validity[0] && (
            <ValidationComponent
              fieldStore={fieldStore}
              handleClick={this.focusAfterDelete}
            />
          )}
        </NumberInput>
      </Tag>
    );
  }
}
